"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kpi = exports.getMultipleAudiencesKpi = exports.getSingleAudienceKpi = void 0;
const createApi_1 = require("../../../../helpers/createApi");
// Backend
const getSingleAudienceKpi = (caller) => (options) => {
    const { accountId, audienceId } = options;
    const url = `/backend/accounts/${accountId}/audiences/${audienceId}/kpi`;
    return caller(url)
        .get()
        .then((kpi) => kpi);
};
exports.getSingleAudienceKpi = getSingleAudienceKpi;
const getMultipleAudiencesKpi = (caller) => (options) => {
    const { accountId, audienceIds } = options;
    const query = audienceIds.map((id) => `audiencesIds[]=${id}`);
    let url = `/backend/accounts/${accountId}/audiences/kpi`;
    if (audienceIds.length) {
        url = url.concat('?').concat(query.join('&'));
    }
    return caller(url)
        .get()
        .then((kpi) => kpi);
};
exports.getMultipleAudiencesKpi = getMultipleAudiencesKpi;
exports.kpi = (0, createApi_1.createAPIFactory)({
    get: exports.getSingleAudienceKpi,
    getList: exports.getMultipleAudiencesKpi,
});
//# sourceMappingURL=api.js.map